import { Rules } from '@shared/components/form-item/model';

export const checkText = (value: unknown, rules: Rules | undefined): boolean => {
  if (!rules || typeof value !== 'string') {
    return true;
  }
  if (typeof rules?.min === 'number' && rules.min > value.length) {
    return false;
  }
  if (rules?.regexp) {
    const regexp = new RegExp(rules.regexp);
    return regexp.test(value);
  }
  if (rules?.textRegex) {
    const regexp = new RegExp('\\b' + rules.textRegex + '\\b');
    return regexp.test(value);
  }
  return true;
};
